module.exports = __webpack_public_path__ + "img/teal-ribbon.0c670024.svg";